module.exports = __webpack_public_path__ + "static/media/hearts-left.2a6e8397.png";